module.exports = __webpack_public_path__ + "img/people.167614ce.png";